import React from "react";
import { useDispatch, useSelector } from "react-redux";
import * as AppActions from "../../redux/actions/app.actions";
import { Container } from "./AddTicketBlockModal";
import {
  ModalContainer,
  ModalHeader,
  ModalContent,
  ModalFooter,
} from "./Modal";
import { BackstageState } from "../../redux/store";
import { Section } from "./UserOrderTicketModal";
import { Flex } from "@sellout/ui";
import styled from "styled-components";
import { OrderItemStateEnum } from "../SelectTicketAddons";
import { SharedInfoText } from "./ChildSharedTicketsModal";

const KeyContainer = styled.div`
  width: 150px;
  font-size: 1.2rem;
  color: #333333;
  font-weight: 500;
  text-align: left;
`;

const ValueContainer = styled.div`
  flex: 1;
  font-size: 1.2rem;
  color: #333333;
  font-weight: 600;
  text-align: left;
`;

enum ModalProps {
  title = "Sharing information",
}

export enum KeyContainerLabels {
  EventName = "Event Name",
  Email = "Email",
  PhoneNumber = "Phone Number",
  OrderID = "Order ID",
  Status = "Status",
}
export enum SharedInfoLabels {
  SharedTo = "Shared To",
  SharedBy = "Shared By",
}
export const ParentSharedByModal = () => {
  /* Actions */
  const dispatch = useDispatch();
  const appState = useSelector((state: BackstageState) => state.app);
  const { modal } = appState;
  const parentsTicketsAddOnsHistory = modal?.modalProps?.ParentSharedByModal;
  const dataOfSharedByModal = modal?.modalProps?.ParentSharedByModal?.filter(
    (item) => item?.matched && Object.keys(item.matched).length > 0
  );
  const popModal = () => dispatch(AppActions.popModal());
  return (
    <ModalContainer width="430px">
      <ModalHeader title={ModalProps.title} close={popModal} />
      <ModalContent>
        <Container>
          {dataOfSharedByModal?.length > 0 && (
            <Section>
              <SharedInfoText>{SharedInfoLabels.SharedTo}</SharedInfoText>
              {dataOfSharedByModal?.map((history) => (
                <>
                  <Flex justify="space-between" margin="10px">
                    <KeyContainer>{KeyContainerLabels.EventName}</KeyContainer>
                    <ValueContainer>{history?.matched?.eventName || "N/A"}</ValueContainer>
                  </Flex>
                  <Flex justify="space-between" margin="10px">
                    <KeyContainer>{KeyContainerLabels.Email}</KeyContainer>
                    <ValueContainer>{history?.matched?.email || "N/A"}</ValueContainer>
                  </Flex>
                  <Flex justify="space-between" margin="10px">
                    <KeyContainer>{KeyContainerLabels.PhoneNumber}</KeyContainer>
                    <ValueContainer>{history?.matched?.phoneNumber || "N/A"}</ValueContainer>
                  </Flex>
                  <Flex justify="space-between" margin="10px">
                    <KeyContainer>{KeyContainerLabels.OrderID}</KeyContainer>
                    <ValueContainer>{history?.matched?.orderId || "N/A"}</ValueContainer>
                  </Flex>
                  <Flex justify="space-between" margin="10px">
                    <KeyContainer>{KeyContainerLabels.Status}</KeyContainer>
                    <ValueContainer>{history?.matched?.status || "N/A"}</ValueContainer>
                  </Flex>
                </>
              ))}
            </Section>
          )}
          <SharedInfoText>{SharedInfoLabels.SharedBy}</SharedInfoText>

          <Section>
            {parentsTicketsAddOnsHistory.map(
              (history: { parentOrderDetails; parentOrderId }) => (
                <>
                  <Flex justify="space-between" margin="10px">
                    <KeyContainer>{KeyContainerLabels.EventName}</KeyContainer>
                    <ValueContainer>{history?.parentOrderDetails?.eventName || "N/A"}</ValueContainer>
                  </Flex>
                  <Flex justify="space-between" margin="10px">
                    <KeyContainer>{KeyContainerLabels.Email}</KeyContainer>
                    <ValueContainer>{history?.parentOrderDetails?.email || "N/A"}</ValueContainer>
                  </Flex>
                  <Flex justify="space-between" margin="10px">
                    <KeyContainer>{KeyContainerLabels.PhoneNumber}</KeyContainer>
                    <ValueContainer>{history?.parentOrderDetails?.phoneNumber || "N/A"}</ValueContainer>
                  </Flex>
                  <Flex justify="space-between" margin="10px">
                    <KeyContainer>{KeyContainerLabels.OrderID}</KeyContainer>
                    <ValueContainer>{history?.parentOrderId || "N/A"}</ValueContainer>
                  </Flex>
                  <Flex justify="space-between" margin="10px">
                    <KeyContainer>{KeyContainerLabels.Status}</KeyContainer>
                    <ValueContainer>{OrderItemStateEnum.Shared}</ValueContainer>
                  </Flex>
                </>
              )
            )}
          </Section>
        </Container>
      </ModalContent>
      <ModalFooter></ModalFooter>
    </ModalContainer>
  );
};
